import { LinkedHashMap1zhqxkxv3xnkl as LinkedHashMap } from '../../../../../kotlin-kotlin-stdlib/kotlin/collections/LinkedHashMap.mjs';
import { Unit_instance3kz1zqli6gr1r as Unit_instance } from '../../../../../kotlin-kotlin-stdlib/kotlin/Unit.mjs';
import { invalidTrailingComma2uwwnmbqspks2 as invalidTrailingComma } from './JsonExceptions.mjs';
import {
  JsonObjectee06ihoeeiqj as JsonObject,
  JsonArray2urf8ey7u44sd as JsonArray,
  JsonNull_getInstance1i1hv1sbjynto as JsonNull_getInstance,
  JsonLiteral1u57id0qmqut7 as JsonLiteral,
} from '../JsonElement.mjs';
import { ArrayList3it5z8td81qkl as ArrayList } from '../../../../../kotlin-kotlin-stdlib/kotlin/collections/ArrayListJs.mjs';
import {
  DeepRecursiveFunction3r49v8igsve1g as DeepRecursiveFunction,
  invoke246lvi6tzooz1 as invoke,
} from '../../../../../kotlin-kotlin-stdlib/kotlin/DeepRecursive.mjs';
import { orPromise1iucc2to2udt2 as orPromise } from '../../../../../kotlin-kotlin-stdlib/kotlin/coroutines/intrinsics/coroutinesInteropJs.mjs';
import { constructCallableReference23y65rf941mch as constructCallableReference } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/reflectRuntime.mjs';
import { tokenDescription3r6eqmtoxe76u as tokenDescription } from './AbstractJsonLexer.mjs';
import { initMetadataForClassbxx6q50dy2s7 as initMetadataForClass } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
function readObject($this) {
  // Inline function 'kotlinx.serialization.json.internal.JsonTreeReader.readObjectImpl' call
  var lastToken = $this.lexer_1.consumeNextToken_dugwfi_k$(6);
  if ($this.lexer_1.peekNextToken_1gqwr9_k$() === 4) {
    $this.lexer_1.fail$default_ly4hfp_k$('Unexpected leading comma');
  }
  // Inline function 'kotlin.collections.linkedMapOf' call
  var result = LinkedHashMap().new_kotlin_collections_LinkedHashMap_ga0any_k$();
  $l$loop: while ($this.lexer_1.canConsumeValue_oljqd7_k$()) {
    var key = $this.isLenient_1 ? $this.lexer_1.consumeStringLenient_9oypvu_k$() : $this.lexer_1.consumeString_j3j2z7_k$();
    $this.lexer_1.consumeNextToken_dugwfi_k$(5);
    var element = $this.read_22xsm_k$();
    // Inline function 'kotlin.collections.set' call
    result.put_4fpzoq_k$(key, element);
    lastToken = $this.lexer_1.consumeNextToken_uf1vsa_k$();
    var tmp0_subject = lastToken;
    if (tmp0_subject !== 4)
      if (tmp0_subject === 7)
        break $l$loop;
      else {
        $this.lexer_1.fail$default_ly4hfp_k$('Expected end of the object or comma');
      }
  }
  if (lastToken === 6) {
    $this.lexer_1.consumeNextToken_dugwfi_k$(7);
  } else if (lastToken === 4) {
    if (!$this.trailingCommaAllowed_1) {
      invalidTrailingComma($this.lexer_1);
    }
    $this.lexer_1.consumeNextToken_dugwfi_k$(7);
  }
  return new (JsonObject())(result);
}
function *readObject_0($this, $receiver, $completion) {
  // Inline function 'kotlinx.serialization.json.internal.JsonTreeReader.readObjectImpl' call
  var lastToken = $this.lexer_1.consumeNextToken_dugwfi_k$(6);
  if ($this.lexer_1.peekNextToken_1gqwr9_k$() === 4) {
    $this.lexer_1.fail$default_ly4hfp_k$('Unexpected leading comma');
  }
  // Inline function 'kotlin.collections.linkedMapOf' call
  var result = LinkedHashMap().new_kotlin_collections_LinkedHashMap_ga0any_k$();
  $l$loop: while ($this.lexer_1.canConsumeValue_oljqd7_k$()) {
    var key = $this.isLenient_1 ? $this.lexer_1.consumeStringLenient_9oypvu_k$() : $this.lexer_1.consumeString_j3j2z7_k$();
    $this.lexer_1.consumeNextToken_dugwfi_k$(5);
    var element = yield* $receiver.callRecursive_g04ojy_k$(Unit_instance, $completion);
    // Inline function 'kotlin.collections.set' call
    result.put_4fpzoq_k$(key, element);
    lastToken = $this.lexer_1.consumeNextToken_uf1vsa_k$();
    var tmp0_subject = lastToken;
    if (tmp0_subject !== 4)
      if (tmp0_subject === 7)
        break $l$loop;
      else {
        $this.lexer_1.fail$default_ly4hfp_k$('Expected end of the object or comma');
      }
  }
  if (lastToken === 6) {
    $this.lexer_1.consumeNextToken_dugwfi_k$(7);
  } else if (lastToken === 4) {
    if (!$this.trailingCommaAllowed_1) {
      invalidTrailingComma($this.lexer_1);
    }
    $this.lexer_1.consumeNextToken_dugwfi_k$(7);
  }
  return new (JsonObject())(result);
}
function readArray($this) {
  var lastToken = $this.lexer_1.consumeNextToken_uf1vsa_k$();
  if ($this.lexer_1.peekNextToken_1gqwr9_k$() === 4) {
    $this.lexer_1.fail$default_ly4hfp_k$('Unexpected leading comma');
  }
  // Inline function 'kotlin.collections.arrayListOf' call
  var result = ArrayList().new_kotlin_collections_ArrayList_ony0vx_k$();
  while ($this.lexer_1.canConsumeValue_oljqd7_k$()) {
    var element = $this.read_22xsm_k$();
    result.add_utx5q5_k$(element);
    lastToken = $this.lexer_1.consumeNextToken_uf1vsa_k$();
    if (!(lastToken === 4)) {
      var tmp0 = $this.lexer_1;
      // Inline function 'kotlinx.serialization.json.internal.AbstractJsonLexer.require' call
      var condition = lastToken === 9;
      var position = tmp0.currentPosition_1;
      if (!condition) {
        var tmp$ret$2 = 'Expected end of the array or comma';
        tmp0.fail$default_ly4hfp_k$(tmp$ret$2, position);
      }
    }
  }
  if (lastToken === 8) {
    $this.lexer_1.consumeNextToken_dugwfi_k$(9);
  } else if (lastToken === 4) {
    if (!$this.trailingCommaAllowed_1) {
      invalidTrailingComma($this.lexer_1, 'array');
    }
    $this.lexer_1.consumeNextToken_dugwfi_k$(9);
  }
  return new (JsonArray())(result);
}
function readValue($this, isString) {
  var tmp;
  if ($this.isLenient_1 || !isString) {
    tmp = $this.lexer_1.consumeStringLenient_9oypvu_k$();
  } else {
    tmp = $this.lexer_1.consumeString_j3j2z7_k$();
  }
  var string = tmp;
  if (!isString && string === 'null')
    return JsonNull_getInstance();
  return new (JsonLiteral())(string, isString);
}
function readDeepRecursive($this) {
  return invoke(new (DeepRecursiveFunction())(JsonTreeReader$readDeepRecursive$slambda($this)), Unit_instance);
}
function JsonTreeReader$readDeepRecursive$slambda(this$0) {
  return constructCallableReference(($this$DeepRecursiveFunction, it, $completion) => orPromise($completion, function *($completion) {
    var tmp0_subject = this$0.lexer_1.peekNextToken_1gqwr9_k$();
    var tmp;
    if (tmp0_subject === 1) {
      tmp = readValue(this$0, true);
    } else if (tmp0_subject === 0) {
      tmp = readValue(this$0, false);
    } else if (tmp0_subject === 6) {
      tmp = yield* /*#__NOINLINE__*/readObject_0(this$0, $this$DeepRecursiveFunction, $completion);
    } else if (tmp0_subject === 8) {
      tmp = readArray(this$0);
    } else {
      this$0.lexer_1.fail$default_ly4hfp_k$("Can't begin reading element, unexpected token");
    }
    return tmp;
  }), 2);
}
var JsonTreeReaderClass;
function JsonTreeReader() {
  if (JsonTreeReaderClass === VOID) {
    class $ {
      constructor(configuration, lexer) {
        this.lexer_1 = lexer;
        this.isLenient_1 = configuration.isLenient_1;
        this.trailingCommaAllowed_1 = configuration.allowTrailingComma_1;
        this.stackDepth_1 = 0;
      }
      read_22xsm_k$() {
        var token = this.lexer_1.peekNextToken_1gqwr9_k$();
        var tmp;
        if (token === 1) {
          tmp = readValue(this, true);
        } else if (token === 0) {
          tmp = readValue(this, false);
        } else if (token === 6) {
          var tmp_0;
          this.stackDepth_1 = this.stackDepth_1 + 1 | 0;
          if (this.stackDepth_1 === 200) {
            tmp_0 = readDeepRecursive(this);
          } else {
            tmp_0 = readObject(this);
          }
          var result = tmp_0;
          this.stackDepth_1 = this.stackDepth_1 - 1 | 0;
          tmp = result;
        } else if (token === 8) {
          tmp = readArray(this);
        } else {
          this.lexer_1.fail$default_ly4hfp_k$('Cannot read Json element because of unexpected ' + tokenDescription(token));
        }
        return tmp;
      }
    }
    initMetadataForClass($, 'JsonTreeReader', VOID, VOID, VOID, [1]);
    JsonTreeReaderClass = $;
  }
  return JsonTreeReaderClass;
}
//region block: exports
export {
  JsonTreeReader as JsonTreeReader1ycreu77eikqj,
};
//endregion

//# sourceMappingURL=JsonTreeReader.mjs.map
